import * as t from "io-ts";

export const codec = t.type({
    id: t.string,
    primary_number: t.boolean,
    user_id: t.string,
    phone_number: t.union([
        t.string,
        t.null,
    ]),
});

export type T = t.TypeOf<typeof codec>;

export const newDefault = (): T => ({
    id: "",
    user_id: "",
    phone_number: "",
    primary_number: true,
});
